import { inlineOnboardingMessages } from './messages';
import { DocNode, PanelType } from '@atlaskit/adf-schema';

export type OnboardingTemplate = {
	atlas_doc_format: {
		value: DocNode;
		representation: 'atlas_doc_format';
	};
};

export const inlineOnboardingTemplateJson: OnboardingTemplate = {
	atlas_doc_format: {
		value: {
			type: 'doc',
			content: [
				{
					type: 'panel',
					attrs: {
						panelIconId: '1f44b',
						panelIcon: ':wave:',
						panelIconText: '👋',
						panelColor: '#DEEBFF',
						panelType: PanelType.CUSTOM,
					},
					content: [
						{
							type: 'paragraph',
							content: [
								{
									text: inlineOnboardingMessages.howToUseThesePagesWithinJira.defaultMessage,
									type: 'text',
									marks: [{ type: 'strong' as const }],
								},
							],
						},
						{
							type: 'taskList',
							attrs: { localId: '' },
							content: [
								{
									type: 'taskItem',
									attrs: { state: 'TODO', localId: '19' },
									content: [
										{
											text: inlineOnboardingMessages.type.defaultMessage + ' ',
											type: 'text',
										},
										{
											text: '/' + inlineOnboardingMessages.jira.defaultMessage,
											type: 'text',
											marks: [{ type: 'code' as const }],
										},
										{
											text: ' ' + inlineOnboardingMessages.task1.defaultMessage,
											type: 'text',
										},
									],
								},
								{
									type: 'taskItem',
									attrs: { state: 'TODO', localId: '20' },
									content: [
										{
											text: inlineOnboardingMessages.task2.defaultMessage,
											type: 'text',
										},
									],
								},
								{
									type: 'taskItem',
									attrs: { state: 'TODO', localId: '21' },
									content: [
										{
											text: inlineOnboardingMessages.type.defaultMessage + ' ',
											type: 'text',
										},
										{
											text: '/',
											type: 'text',
											marks: [{ type: 'code' as const }],
										},
										{
											text: ' ' + inlineOnboardingMessages.task3.defaultMessage,
											type: 'text',
										},
									],
								},
							],
						},
					],
				},
			],
			version: 1,
		},
		representation: 'atlas_doc_format' as const,
	},
};
